/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Row_Org_Default_HintInputs */



/**
* | output |
* | --- |
* | "The base value applied when no team or user override matches." |
*
* @param {Rights_Row_Org_Default_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_row_org_default_hint = /** @type {((inputs?: Rights_Row_Org_Default_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Row_Org_Default_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Basiswert, der gilt, wenn keine Team- oder Nutzer-Ausnahme zutrifft.")
	return /** @type {LocalizedString} */ ("The base value applied when no team or user override matches.")
});